(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eurotex-cart-api"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const key = 'eurotex-pilot-basket-v1';
    const artworkKey = 'eurotex-artwork-choice-v1';
    function start() {
      const root = document.querySelector('[data-et-cart]');
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const $ = selector => root.querySelector(selector);
      const message = $('[data-cart-message]');
      const content = $('[data-cart-content]');
      const empty = $('[data-cart-empty]');
      const rows = $('[data-cart-items]');
      const total = $('[data-cart-total]');
      const email = $('[data-cart-email]');
      const quoteButton = $('[data-cart-quote]');
      const checkoutButton = $('[data-cart-checkout]');
      let basket = [];
      let quote = null;
      let ready = false;
      let quoteReady = false;
      let checkoutStatusByCode = new Map();
      let quoteStatusByCode = new Map();
      let productDataByCode = new Map();
      let busy = false;
      let priceRevision = 0;
      function readBasket() {
        try {
          const saved = JSON.parse(localStorage.getItem(key) || '[]');
          basket = Array.isArray(saved) ? saved.slice(0, 10).filter(item => item && item.line && item.label) : [];
        } catch (_) { basket = []; }
      }
      function basketProductCodes() {
        return [...new Set(basket.map(item => String(item?.line?.product_code || '').trim()).filter(Boolean))];
      }
      function blockedProductCodes() {
        return basketProductCodes().filter(code => checkoutStatusByCode.get(code) === false);
      }
      function updateReadyFromBasket() {
        const codes = basketProductCodes();
        ready = codes.length > 0 && codes.every(code => checkoutStatusByCode.get(code) === true);
        quoteReady = codes.length > 0 && codes.every(code => quoteStatusByCode.get(code) === true);
      }
      function stockAllowed() { return quote?.stock_checkout_allowed === true; }
      function stockMessage() {
        return quote?.stock?.some(item => ['insufficient', 'unavailable'].includes(item.status))
          ? 'Niet voldoende direct op voorraad. Levertijd op aanvraag.'
          : 'Voorraad wordt gecontroleerd. Levertijd op aanvraag.';
      }
      function canRequestPricedQuote() {
        return Number(root.dataset.nativeCount) === 0 && quoteReady && quote && quote.minimum_met !== false && stockAllowed();
      }
      function updateButtons() {
        quoteButton.disabled = busy || !basket.length;
        quoteButton.textContent = canRequestPricedQuote() ? 'Offerte aanvragen' : 'Offerte laten controleren';
        checkoutButton.disabled = busy || Number(root.dataset.nativeCount) > 0 || !ready || !quote || quote.minimum_met === false || !stockAllowed();
      }
      function manualQuoteUrl() {
        const destination = new URL('/pages/alle-blouse', window.location.origin);
        destination.searchParams.set('eurotex_offerte', 'winkelwagen');
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) destination.searchParams.set('preview_theme_id', preview);
        destination.hash = 'ContactForm';
        return destination.href;
      }
      function blockedProductMessage() {
        const blocked = new Set(blockedProductCodes());
        const labels = [];
        const seen = new Set();
        basket.forEach(item => {
          const code = String(item?.line?.product_code || '').trim();
          const label = String(item?.label || code).trim();
          if (blocked.has(code) && label && !seen.has(label)) {
            seen.add(label);
            labels.push(label);
          }
        });
        const names = labels.length ? ` (${labels.join(', ')})` : '';
        return `Direct afrekenen is nog niet beschikbaar voor een product${names}. Je kunt wel een offerte aanvragen. We controleren de volledige samenstelling voor je.`;
      }
      function hasPrintedItems() { return basket.some(item => Boolean(item?.line?.print_group)); }
      function readArtworkChoice() {
        try {
          const value = JSON.parse(localStorage.getItem(artworkKey) || 'null');
          if (!value || typeof value !== 'object') return null;
          if (value.mode === 'later') return { mode: 'later' };
          if (value.mode === 'uploaded' && typeof value.artwork_id === 'string' && value.artwork_id.trim()) {
            return { mode: 'uploaded', artwork_id: value.artwork_id.trim() };
          }
          return null;
        } catch (_) { return null; }
      }
      function money(value) { return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(Number(value)); }
      function explain(reason) {
        if (reason === 'stock_requires_manual_review') return 'Voorraad wordt gecontroleerd. Levertijd op aanvraag.';
        if (reason === 'printed_order_below_eurotex_minimum') return 'Bedrukte bestellingen moeten minimaal € 100 excl. btw zijn. Verhoog een aantal of verwijder een regel.';
        if (reason === 'draft_orders_disabled') return 'De prijsberekening werkt. De bestel- en offertestroom wordt nog klaargezet.';
        if (reason === 'price_changed') return 'De actuele prijs is veranderd. Controleer het nieuwe totaal en probeer opnieuw.';
        if (reason === 'one_or_more_lines_need_manual_review') return 'Een product heeft prijsinformatie nodig die we eerst handmatig moeten controleren. Neem contact met ons op voor een offerte.';
        if (reason === 'artwork_choice_required' || reason === 'invalid_artwork_choice') return 'Kies bij Logo voor bedrukking of je het logo nu toevoegt of later aanlevert.';
        if (reason === 'invalid_artwork_id' || reason === 'artwork_not_found') return 'Het opgeslagen logo kan niet meer worden gevonden. Upload je logo opnieuw.';
        if (reason === 'artwork_metadata_corrupt') return 'Het opgeslagen logo kan nu niet veilig worden gekoppeld. Upload je logo opnieuw of kies later aanleveren.';
        return 'We konden de bestelling nu niet verwerken. Controleer je keuzes of probeer het later opnieuw.';
      }
      async function api(path, body) {
        const response = await fetch(`${root.dataset.api}${path}`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: AbortSignal.timeout(60000) });
        const data = await response.json();
        if (!response.ok) throw new Error(explain(data.reason));
        return data;
      }
      function drawRows() {
        rows.replaceChildren();
        basket.forEach((item, index) => {
          const code = String(item?.line?.product_code || '').trim();
          const productData = productDataByCode.get(code);
          const selectedColor = productData?.colors?.find(color => color.code === item.line.color_code);
          const selectedPrint = productData?.print_options?.find(option =>
            option.print_group === item.line.print_group &&
            String(option.number_of_colors) === String(item.line.number_of_colors) &&
            (!item.line.position || option.position === item.line.position)
          );
          const fallbackTitle = String(item.label || code).split(' · ')[0].trim();
          const escapedCode = code.replace(/[.*+?^$\{\}()|[\]\\]/g, '\\$&');
          const title = String(productData?.title || fallbackTitle || code).replace(new RegExp('\\s+' + escapedCode + '$', 'i'), '');

          const productUrl = new URL(item.url || '', window.location.origin);
          const isProductUrl = productUrl.origin === window.location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[a-z0-9][a-z0-9-]*\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(productUrl.pathname);
          const view = productUrl.searchParams.get('view');
          const suffix = view && /^eurotex-[a-z0-9-]+$/.test(view) ? view : code === 'LT87821' ? 'eurotex-hawaii' : 'eurotex-catalog';
          const previewCode = productUrl.origin === window.location.origin && productUrl.pathname === '/' && /^LT[0-9]{5}$/.test(productUrl.searchParams.get('et_product') || '') ? productUrl.searchParams.get('et_product') : '';
          const href = previewCode ? '/?et_product=' + encodeURIComponent(previewCode) : isProductUrl ? `${productUrl.pathname}?view=${encodeURIComponent(suffix)}` : '/collections/all';

          const row = document.createElement('li');
          const imageLink = document.createElement('a');
          imageLink.href = href;
          imageLink.className = 'et-cart__product-image-link';
          imageLink.setAttribute('aria-label', title);
          if (selectedColor?.image) {
            const image = document.createElement('img');
            image.className = 'et-cart__product-image';
            image.src = selectedColor.image;
            image.alt = `${title} · ${selectedColor.title || item.line.color_code}`;
            image.loading = 'lazy';
            imageLink.append(image);
          } else {
            const placeholder = document.createElement('span');
            placeholder.className = 'et-cart__product-image-placeholder';
            placeholder.textContent = 'Product';
            imageLink.append(placeholder);
          }

          const details = document.createElement('div');
          details.className = 'et-cart__details';
          const link = document.createElement('a');
          link.href = href;
          link.textContent = title;
          const meta = document.createElement('div');
          meta.className = 'et-cart__meta';
          const colorMeta = document.createElement('span');
          colorMeta.textContent = `Kleur: ${selectedColor?.title || item.line.color_code || 'Onbekend'}`;
          const printMeta = document.createElement('span');
          printMeta.textContent = item.line.print_group
            ? `Bedrukking: ${selectedPrint?.method || item.line.print_group}${item.line.number_of_colors ? ` · ${item.line.number_of_colors} kleur${Number(item.line.number_of_colors) === 1 ? '' : 'en'}` : ''}`
            : 'Bedrukking: Onbedrukt';
          meta.append(colorMeta, printMeta);
          if (item.line.print_group && item.line.position) {
            const positionMeta = document.createElement('span');
            positionMeta.textContent = `Positie: ${selectedPrint?.position_title || item.line.position}`;
            meta.append(positionMeta);
          }
          const linePrice = document.createElement('p');
          linePrice.className = 'et-cart__line-price';
          linePrice.dataset.cartLinePrice = String(index);
          details.append(link, meta, linePrice);

          const lineActions = document.createElement('div');
          lineActions.className = 'et-cart__line-actions';
          const quantityWrap = document.createElement('div');
          quantityWrap.className = 'et-cart__quantity';
          const quantityLabel = document.createElement('label');
          const quantityId = `EtCartQuantity-${index}`;
          quantityLabel.htmlFor = quantityId;
          quantityLabel.textContent = 'Aantal stuks';
          const quantityInput = document.createElement('input');
          quantityInput.id = quantityId;
          quantityInput.type = 'number';
          quantityInput.min = '1';
          quantityInput.step = '1';
          quantityInput.inputMode = 'numeric';
          quantityInput.value = String(Number(item.line.quantity) || 1);
          quantityInput.setAttribute('aria-label', `Aantal stuks voor ${title}`);
          quantityInput.dataset.cartQuantity = String(index);
          quantityInput.addEventListener('change', () => {
            const nextQuantity = Number(quantityInput.value);
            if (!Number.isInteger(nextQuantity) || nextQuantity < 1) {
              quantityInput.value = String(Number(item.line.quantity) || 1);
              message.textContent = 'Vul een heel aantal van minimaal 1 stuk in.';
              return;
            }
            item.line.quantity = nextQuantity;
            item.label = item.label.replace(/\b\d+\s+stuks\b/i, `${nextQuantity} stuks`);
            localStorage.setItem(key, JSON.stringify(basket));
            window.dispatchEvent(new Event('eurotex:basket-updated'));
            message.textContent = 'Aantal bijgewerkt. De prijs wordt opnieuw berekend…';
            reprice();
          });
          quantityWrap.append(quantityLabel, quantityInput);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.cartRemove = '';
          remove.textContent = 'Verwijderen';
          remove.addEventListener('click', () => {
            basket.splice(index, 1);
            localStorage.setItem(key, JSON.stringify(basket));
            window.dispatchEvent(new Event('eurotex:basket-updated'));
            updateReadyFromBasket();
            render();
          });
          lineActions.append(quantityWrap, remove);
          row.append(imageLink, details, lineActions);
          rows.append(row);
        });
      }
      async function reprice() {
        const revision = ++priceRevision;
        quote = null;
        total.textContent = '';
        updateButtons();
        checkoutButton.disabled = true;
        if (!basket.length) return;
        try {
          const data = await api('/quote', { lines: basket.map(item => item.line) });
          if (revision !== priceRevision) return;
          if (data.status !== 'priced') { total.textContent = 'Prijs wordt door ons bevestigd'; message.textContent = 'We controleren de prijs en beschikbaarheid van deze samenstelling handmatig. Gebruik Offerte laten controleren.'; updateButtons(); return; }
          quote = data;
          total.textContent = money(data.total_ex_vat);
          data.lines.forEach((line, index) => {
            const price = root.querySelector(`[data-cart-line-price="${index}"]`);
            if (price) price.textContent = `${money(line.customer_total_ex_vat)} excl. btw`;
          });
          const belowMinimum = data.minimum_met === false;
          const blockedCodes = blockedProductCodes();
          updateButtons();
          message.textContent = Number(root.dataset.nativeCount) > 0
            ? 'Je winkelwagen bevat ook eerder bewaarde artikelen. Laat de volledige samenstelling controleren via Offerte laten controleren.'
            : !stockAllowed()
            ? stockMessage()
            : blockedCodes.length
            ? blockedProductMessage()
            : belowMinimum
              ? `Voeg nog ${money(data.shortfall_ex_vat)} toe om een bedrukte bestelling van minimaal € 100 excl. btw te plaatsen.`
              : ready
                ? ''
                : 'Direct afrekenen is nu niet beschikbaar. Laat je samenstelling controleren via een offerteaanvraag.';
        } catch (error) { if (revision === priceRevision) { total.textContent = 'Prijs wordt door ons bevestigd'; message.textContent = 'De prijs kon nu niet worden bevestigd. Je kunt je samenstelling wel laten controleren via een offerteaanvraag.'; updateButtons(); } }
      }
      function render() {
        const hasItems = basket.length > 0;
        const native = document.querySelector('[data-et-native-cart]');
        if (native) {
          native.hidden = hasItems && Number(root.dataset.nativeCount) === 0;
          root.hidden = !hasItems;
          root.querySelector('[data-et-separate-orders]')?.toggleAttribute('hidden', !hasItems);
        }
        content.hidden = !hasItems;
        empty.hidden = hasItems;
        root.querySelector('[data-cart-proof]')?.toggleAttribute('hidden', !hasPrintedItems());
        if (!hasItems) {
          priceRevision += 1;
          quote = null;
          rows.replaceChildren();
          total.textContent = '';
          message.textContent = '';
          updateButtons();
          return;
        }
        drawRows();
        reprice();
      }
      async function submit(mode) {
        if (busy || !basket.length) return;
        if (mode === 'quote' && !canRequestPricedQuote()) {
          window.location.assign(manualQuoteUrl());
          return;
        }
        if (mode === 'checkout' && !stockAllowed()) {
          message.textContent = stockMessage();
          updateButtons();
          return;
        }
        if (!quote || quote.minimum_met === false || (mode === 'checkout' && (!ready || Number(root.dataset.nativeCount) > 0))) return;
        if (!email.reportValidity()) return;
        const artwork = readArtworkChoice();
        if (hasPrintedItems() && !artwork) {
          message.textContent = explain('artwork_choice_required');
          root.querySelector('[data-cart-artwork]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        busy = true;
        quoteButton.disabled = true;
        checkoutButton.disabled = true;
        message.textContent = mode === 'quote' ? 'Je offerteaanvraag wordt klaargezet…' : 'De beveiligde checkout wordt klaargezet…';
        try {
          const payload = {
            artwork_flow_version: 1,
            request_id: quote.quote_reference,
            mode,
            email: email.value.trim(),
            lines: basket.map(item => item.line),
            expected_total_ex_vat: quote.total_ex_vat
          };
          if (artwork) payload.artwork = artwork;
          const data = await api('/draft-order', payload);
          if (mode === 'quote' && data.status === 'quote_requested') {
            basket = [];
            localStorage.removeItem(key);
            localStorage.removeItem(artworkKey);
            window.dispatchEvent(new Event('eurotex:basket-updated'));
            priceRevision += 1;
            quote = null;
            rows.replaceChildren();
            total.textContent = '';
            content.hidden = true;
            empty.hidden = true;
            root.hidden = false;
            const native = document.querySelector('[data-et-native-cart]');
            if (native) native.hidden = true;
            root.querySelector('[data-et-separate-orders]')?.setAttribute('hidden', '');
            root.querySelector('h1').textContent = 'Offerteaanvraag ontvangen';
            root.querySelector('h1 + p')?.setAttribute('hidden', '');
            document.querySelectorAll('.quotify-request-quote-btn').forEach(button => {
              button.hidden = true;
              button.setAttribute('aria-hidden', 'true');
            });
            const artworkNote = artwork?.mode === 'uploaded'
              ? ' Je logo is veilig toegevoegd. Je ontvangt altijd eerst een gratis digitale proefdruk. We starten pas met produceren na jouw akkoord.'
              : artwork?.mode === 'later'
                ? ' Je hebt gekozen om je logo later aan te leveren. Je ontvangt altijd eerst een gratis digitale proefdruk. We starten pas met produceren na jouw akkoord.'
                : '';
            message.classList.add('is-success');
            message.textContent = `Bedankt! We hebben je offerteaanvraag ontvangen en nemen contact met je op via het opgegeven e-mailadres.${artworkNote}`;
            message.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          if (data.status !== 'created' || !data.checkout_url) throw new Error(explain(data.reason));
          const destination = new URL(data.checkout_url);
          if (destination.protocol !== 'https:') throw new Error(explain(''));
          window.location.assign(destination.href);
        } catch (error) { message.textContent = error.message || explain(''); }
        finally { busy = false; updateButtons(); }
      }
      quoteButton.addEventListener('click', () => submit('quote'));
      checkoutButton.addEventListener('click', () => submit('checkout'));
      window.addEventListener('eurotex:artwork-updated', () => {
        if (ready && quote && quote.minimum_met !== false && stockAllowed()) message.textContent = '';
      });
      readBasket();
      const productCodes = basketProductCodes();
      if (!productCodes.length) {
        render();
        return;
      }
      render();
      Promise.all(productCodes.map(code => fetch(`${root.dataset.api}/products/${encodeURIComponent(code)}`, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) })
        .then(response => response.json())
        .then(data => ({ code, data }))))
        .then(results => {
          productDataByCode = new Map(results
            .filter(({ data }) => data && data.status === 'ok' && data.product)
            .map(({ code, data }) => [code, data.product]));
          checkoutStatusByCode = new Map(results.map(({ code, data }) => [code, Boolean(data && data.status === 'ok' && data.checkout_enabled === true)]));
          quoteStatusByCode = new Map(results.map(({ code, data }) => [code, Boolean(data && data.status === 'ok' && (data.quote_enabled === true || (data.quote_enabled === undefined && data.checkout_enabled === true)))]));
          updateReadyFromBasket();
          render();
        })
        .catch(() => {
          checkoutStatusByCode = new Map();
          quoteStatusByCode = new Map();
          ready = false;
          quoteReady = false;
          render();
          message.textContent = explain('');
        });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eurotex-collection-catalog"]) return;
  try {
    
  document.querySelectorAll('[data-et-live-navigation]').forEach(nav => {
    const mobile = matchMedia('(max-width: 749px)');
    nav.open = !mobile.matches;
    mobile.addEventListener('change', event => { nav.open = !event.matches; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eurotex-configurator-pilot"]) return;
  try {
    
    (() => {
      const money = amount => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(amount);
      function initialize(root) {
        if (root.dataset.etReady === 'true') return;
        root.dataset.etReady = 'true';
        const quantity = root.querySelector('[data-et-quantity]');
        const finish = root.querySelector('[data-et-finish]');
        const variantInput = root.querySelector('[data-et-variant-id]');
        const price = root.querySelector('[data-et-price]');
        const unitPrice = root.querySelector('[data-et-unit-price]');
        const submit = root.querySelector('[data-et-submit]');
        const setup = root.querySelector('[data-et-setup]');
        const variants = Array.from(root.querySelectorAll('[data-et-variant]'));

        function updateVariant() {
          const selected = variants.find(variant =>
            variant.dataset.quantity === quantity.value &&
            variant.dataset.finishValue === finish.value
          );
          if (!selected) {
            submit.disabled = true;
            return;
          }
          variantInput.value = selected.dataset.variantId;
          submit.disabled = selected.dataset.available !== 'true';
          const cents = Number(selected.dataset.priceCents);
          const units = Number.parseInt(quantity.value, 10);
          price.textContent = money(cents / 100);
          unitPrice.textContent = money(Math.round(cents / units) / 100);
          setup.hidden = finish.value === 'Onbedrukt';
        }

        quantity.addEventListener('change', updateVariant);
        finish.addEventListener('change', updateVariant);
        updateVariant();

        const hero = root.querySelector('[data-et-hero]');
        root.querySelectorAll('[data-et-image-button]').forEach(button => {
          button.addEventListener('click', () => {
            if (!hero) return;
            hero.src = button.dataset.imageUrl;
            hero.alt = button.dataset.imageAlt;
            root.querySelectorAll('[data-et-image-button]').forEach(other => {
              other.classList.toggle('is-active', other === button);
              other.setAttribute('aria-pressed', String(other === button));
            });
          });
        });
      }

      function start() {
        document.querySelectorAll('[data-et-pilot]').forEach(initialize);
      }
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
      else start();
      document.addEventListener('shopify:section:load', start);
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eurotex-preview-catalog"]) return;
  try {
    
  (() => {
    async function start() {
      const root = document.querySelector('[data-et-preview]');
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const $ = selector => root.querySelector(selector);
      const copy = JSON.parse($('[data-et-preview-copy]').textContent);
      const params = new URLSearchParams(location.search);
      const navigation = JSON.parse($('[data-et-category-data]').textContent);
      const navCopy = JSON.parse($('[data-et-navigation-copy]').textContent);
      const browse = params.has('et_catalog') || params.has('et_collection') || params.has('et_product');
      if (browse) {
        root.hidden = false;
        document.querySelector('[data-et-standard-content]')?.setAttribute('hidden','');
      } else {
        // Actual Shopify collection and search URLs must never be intercepted by the legacy preview catalog.
        return;
      }
      try {
        const response = await fetch(root.dataset.source, {signal:AbortSignal.timeout(20000)});
        if (!response.ok) throw new Error(copy.error);
        const catalog = await response.json();
        const handles = new Set(catalog.collections.map(c => c.handle));
        document.addEventListener('click', event => {
          const anchor = event.target.closest('a[href]');
          if (!anchor || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const url = new URL(anchor.href, location.origin);
          if (url.origin !== location.origin) return;
          const match = url.pathname.match(/^\/collections\/([^/]+)\/?$/);
          if (match && (handles.has(match[1]) || match[1] === 'all')) {
            event.preventDefault();
            location.href = '/?' + (match[1] === 'all' ? 'et_catalog=1' : 'et_collection=' + encodeURIComponent(match[1]));
          }
        });
        document.addEventListener('submit', event => {
          if (event.target instanceof HTMLFormElement && new URL(event.target.action,location.origin).pathname === '/search') {
            event.preventDefault();
            location.href = '/?et_catalog=1&et_search=' + encodeURIComponent(new FormData(event.target).get('q') || '');
          }
        });
        if (!browse) return;
        const selected = handles.has(params.get('et_collection')) ? params.get('et_collection') : '';
        const current = catalog.collections.find(c => c.handle === selected);
        const group = navigation.groups.find(g => g.handle === selected) || navigation.groups.find(g => g.children.some(c => c.handle === selected));
        const collectionUrl = handle => '/?' + (handle === 'all' || !handle ? 'et_catalog=1' : 'et_collection=' + encodeURIComponent(handle));
        function makeLink(title, handle, showCount = true) {
          const a = document.createElement('a'); a.href = collectionUrl(handle); a.textContent = title;
          if ((handle === selected) || (!selected && handle === 'all')) a.setAttribute('aria-current','page');
          const count = handle === 'all' ? catalog.products.length : catalog.collections.find(c => c.handle === handle)?.count;
          if (showCount && typeof count === 'number') { const small = document.createElement('small'); small.textContent = count; a.append(small); }
          return a;
        }
        const breadcrumbs = $('[data-et-breadcrumbs]');
        const home = document.createElement('a'); home.href = '/'; home.textContent = navCopy.home; breadcrumbs.append(home);
        const trail = [{title:navCopy.catalog,handle:'all'}];
        if (group && group.handle !== 'all') trail.push(group);
        if (current && current.handle !== group?.handle) trail.push(current);
        trail.forEach((item,index) => { const separator = document.createElement('span'); separator.textContent = '›'; separator.setAttribute('aria-hidden','true'); breadcrumbs.append(separator); const a = makeLink(item.title,item.handle,false); if(index === trail.length-1 && !params.has('et_product')) a.setAttribute('aria-current','page'); breadcrumbs.append(a); });

        const chosen = catalog.products.find(p => p.code === params.get('et_product'));
        if (chosen) {
          $('[data-et-list]').hidden = true;
          $('[data-et-back]').hidden = false;
          $('[data-et-back]').href = collectionUrl(selected) + (params.has('et_sort') ? '&et_sort=' + encodeURIComponent(params.get('et_sort')) : '');
          if (current) $('[data-et-back]').textContent = navCopy.back + ' ' + current.title;
          const separator = document.createElement('span'); separator.textContent = '›'; separator.setAttribute('aria-hidden','true'); const productCrumb = document.createElement('span'); productCrumb.textContent = chosen.title; productCrumb.setAttribute('aria-current','page'); breadcrumbs.append(separator,productCrumb);
          const detail = document.querySelector('[data-et-preview-detail]');
          if (!detail) throw new Error(copy.error);
          detail.hidden = false;
          const product = detail.querySelector('[data-et-product]');
          product.dataset.code = chosen.code;
          product.dataset.previewUrl = '/?et_product=' + encodeURIComponent(chosen.code);
          product.querySelector('[data-product-title]').textContent = chosen.title;
          const img = document.createElement('img');
          img.src = chosen.image; img.alt = chosen.title; img.width=700; img.height=700;
          img.className='et-product__image'; img.dataset.etImage='';
          product.querySelector('.et-product__gallery').replaceChildren(img);
          document.title = chosen.title + ' | Eurotex 2.0';
          document.dispatchEvent(new Event('eurotex:preview-ready'));
          return;
        }
        const grid=$('[data-et-grid]'), more=$('[data-et-more]'), sort=$('[data-et-sort]');
        const term=(params.get('et_search') || '').trim();
        if (['az','za'].includes(params.get('et_sort'))) sort.value=params.get('et_sort');
        const tree=$('[data-et-category-tree]');
        tree.append(makeLink(navCopy.all,'all'));
        navigation.groups.forEach(g => {
          const details=document.createElement('details'); details.className='et-preview__group'; details.open=g===group;
          const summary=document.createElement('summary'); summary.textContent=g.title;
          const list=document.createElement('ul');
          const links=[{title:navCopy.all,handle:g.handle},...g.children.filter(c=>c.handle!==g.handle)];
          links.forEach(item=>{const li=document.createElement('li');li.append(makeLink(item.title,item.handle));list.append(li);});
          details.append(summary,list); tree.append(details);
        });
        const categoryNavigation=$('[data-et-navigation]');
        if (window.matchMedia('(max-width: 749px)').matches) categoryNavigation.open=false;
        $('[data-et-nav-current]').textContent=group?.title || '';
        const quick=$('[data-et-quick-links]');
        const related=group ? [{title:navCopy.all,handle:group.handle},...group.children.filter(c=>c.handle!==group.handle)] : navigation.groups;
        related.forEach(item=>quick.append(makeLink(item.title,item.handle)));
        $('[data-et-subheading]').textContent=group ? navCopy.refine : navCopy.choose;
        $('[data-et-subcategories]').hidden=related.length<2 || !!term;
        $('[data-et-heading]').textContent=term ? navCopy.search + ' “' + term + '”' : (selected===group?.handle ? group.title : current?.title) || copy.title;
        if (group && !term) $('[data-et-intro]').textContent=group.description;
        $('[data-et-reset]').hidden=!term;
        let limit=24;
        function render() {
          const products=catalog.products.filter(p => (!selected || p.collections.includes(selected)) && (!term || `${p.title} ${p.code}`.toLocaleLowerCase('nl').includes(term.toLocaleLowerCase('nl'))));
          if (sort.value !== 'default') products.sort((a,b) => a.title.localeCompare(b.title,'nl',{numeric:true}) * (sort.value==='za' ? -1 : 1));
          $('[data-et-status]').textContent=products.length ? `${products.length} ${copy.count}` : copy.empty;
          grid.replaceChildren(...products.slice(0,limit).map(p => {
            const a=document.createElement('a'); a.className='et-preview__card';
            const productParams=new URLSearchParams({et_product:p.code}); if(selected)productParams.set('et_collection',selected); if(sort.value!=='default')productParams.set('et_sort',sort.value);
            a.href='/?'+productParams;
            if (p.image) {const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.loading='lazy';img.width=400;img.height=400;a.append(img);}
            const title=document.createElement('h2');title.textContent=p.title;
            const label=document.createElement('span');label.textContent=copy.calculate;
            a.append(title,label);return a;
          }));
          more.hidden=limit>=products.length;
        }
        sort.addEventListener('change',()=>{limit=24;const url=new URL(location.href);url.searchParams.delete('et_sort');if(sort.value!=='default')url.searchParams.set('et_sort',sort.value);history.replaceState(null,'',url);render();});
        more.addEventListener('click',()=>{limit+=24;render();});
        render();
      } catch(error) {if(browse)$('[data-et-status]').textContent=copy.error;}
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
    document.addEventListener('shopify:section:load',start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eurotex-product-api"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const $ = selector => root.querySelector(selector);
      const copy = JSON.parse($('[data-copy]').textContent);
      const fields = $('[data-fields]');
      const quantity = $('[data-quantity]'), color = $('[data-color]'), print = $('[data-print]'), position = $('[data-position]');
      const message = $('[data-message]'), summary = $('[data-summary]'), calculate = $('[data-calculate]'), checkout = $('[data-checkout]');
      const minimumWarning = $('[data-minimum-warning]');
      const basketBox = $('[data-basket]'), basketCount = $('[data-basket-count]');
      const add = $('[data-add]');
      const basketKey = 'eurotex-pilot-basket-v1';
      let product, quote = null, quotedLine = null, revision = 0, checkingOut = false, checkoutReady = false;
      let basket = [];
      function readBasket() {
        try {
          const saved = JSON.parse(localStorage.getItem(basketKey) || '[]');
          basket = Array.isArray(saved) ? saved.slice(0, 10).filter(item => item && item.line && item.label) : [];
        } catch (_) { basket = []; }
      }
      readBasket();
      const money = value => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(Number(value));
      function explain(reason) {
        if (reason === 'printed_order_below_eurotex_minimum') return copy.minimum;
        if (reason === 'draft_orders_disabled') return copy.disabled;
        if (reason === 'request_already_processing') return copy.processing;
        if (reason === 'rate_limited') return copy.rate_limited;
        if (reason === 'price_changed' || reason === 'request_details_changed') return copy.recalculate;
        return copy.unavailable;
      }
      function invalidate() {
        revision += 1;
        quote = null;
        quotedLine = null;
        summary.hidden = true;
        minimumWarning.hidden = true;
        minimumWarning.textContent = '';
        calculate.disabled = false;
        message.textContent = copy.recalculate;
      }
      function refreshBasket() {
        basketBox.hidden = basket.length === 0;
        basketCount.textContent = `${basket.length} ${basket.length === 1 ? copy.basket_single : copy.basket_count}`;
      }
      function line() {
        const result = { product_code: root.dataset.code, color_code: color.value, quantity: Number(quantity.value) };
        if (print.value) {
          const [print_group, number_of_colors] = JSON.parse(print.value);
          Object.assign(result, { print_group, number_of_colors, position: position.value });
        }
        return result;
      }
      function updatePositions() {
        const [group, count] = print.value ? JSON.parse(print.value) : ['', ''];
        const options = product.print_options.filter(item => item.print_group === group && item.number_of_colors === count);
        $('[data-position-wrap]').hidden = !group;
        position.replaceChildren(...options.map(item => new Option(item.position_title || item.position, item.position)));
        if (options.some(item => item.position === 'voorzijde')) position.value = 'voorzijde';
        quantity.min = String(Math.max(product.minimum_quantity || 1, ...options.map(item => item.minimum_quantity || 1)));
        invalidate();
      }
      function updateImage() {
        const selected = product.colors.find(item => item.code === color.value);
        const image = $('[data-et-image]');
        if (image && selected && selected.image) {
          image.removeAttribute('srcset');
          image.src = selected.image;
          image.alt = `${product.title} · ${selected.title}`;
        }
      }
      async function api(path, payload) {
        const response = await fetch(`${root.dataset.api}${path}`, {
          method: payload ? 'POST' : 'GET', credentials: 'same-origin',
          headers: payload ? { 'Content-Type': 'application/json' } : {},
          body: payload ? JSON.stringify(payload) : undefined,
          signal: AbortSignal.timeout(60000)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(explain(data.reason));
        return data;
      }
      calculate.addEventListener('click', async () => {
        invalidate();
        if (!quantity.reportValidity() || !color.reportValidity()) return;
        const selectedLine = line();
        const current = revision;
        calculate.disabled = true;
        message.textContent = copy.calculating;
        try {
          const data = await api('/quote', { lines: [selectedLine] });
          if (current !== revision) return;
          if (data.status !== 'priced') throw new Error(explain(data.reason));
          quote = data;
          quotedLine = selectedLine;
          $('[data-total]').textContent = money(data.total_ex_vat);
          $('[data-unit]').textContent = `${money(data.unit_price_ex_vat)} ${copy.per_piece}`;
          const belowMinimum = Boolean(selectedLine.print_group) && data.minimum_met === false;
          if (belowMinimum) {
            const shortfall = Number.isFinite(Number(data.shortfall_ex_vat)) ? Number(data.shortfall_ex_vat) : Math.max(0, 100 - Number(data.total_ex_vat));
            minimumWarning.textContent = copy.minimum_shortfall.replace('__AMOUNT__', money(shortfall));
          }
          minimumWarning.hidden = !belowMinimum;
          $('[data-selection]').textContent = `${selectedLine.quantity} ${copy.pieces} · ${color.selectedOptions[0].text} · ${print.selectedOptions[0].text}${print.value ? ` · ${position.selectedOptions[0].text}` : ''}`;
          summary.hidden = false;
          message.textContent = checkoutReady ? copy.ready : copy.disabled;
        } catch (error) {
          if (current === revision) message.textContent = error.name === 'TimeoutError' ? copy.unavailable : error.message;
        } finally {
          if (current === revision) calculate.disabled = false;
        }
      });
      quantity.addEventListener('input', invalidate);
      color.addEventListener('change', () => { invalidate(); updateImage(); });
      print.addEventListener('change', updatePositions);
      position.addEventListener('change', invalidate);
      add.addEventListener('click', async () => {
        if (!quote || !quotedLine) { message.textContent = copy.recalculate; return; }
        readBasket();
        if (basket.length >= 10) { message.textContent = copy.max_lines; return; }
        const view = new URLSearchParams(window.location.search).get('view');
        const url = window.location.pathname + (view && /^eurotex-[a-z0-9-]+$/.test(view) ? `?view=${encodeURIComponent(view)}` : '');
        basket.push({ line: quotedLine, label: `${product.title} · ${$('[data-selection]').textContent}`, url });
        try { localStorage.setItem(basketKey, JSON.stringify(basket)); }
        catch (_) { basket.pop(); message.textContent = copy.unavailable; return; }
        window.dispatchEvent(new Event('eurotex:basket-updated'));
        message.textContent = copy.added;
        refreshBasket();
      });
      api(`/products/${encodeURIComponent(root.dataset.code)}`).then(data => {
        if (data.status !== 'ok') throw new Error(copy.unavailable);
        product = data.product;
        if (product.title) {
          const codeSuffix = new RegExp('\\s+' + root.dataset.code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$', 'i');
          product.title = product.title.replace(codeSuffix, '');
          $('[data-product-title]').textContent = product.title;
        }
        checkoutReady = data.checkout_enabled === true;
        $('[data-description]').textContent = product.description || '';
        $('[data-description-wrap]').hidden = !product.description;
        color.replaceChildren(...product.colors.map(item => new Option(item.title, item.code)));
        const methods = new Map();
        product.print_options.forEach(item => {
          const count = Number(item.number_of_colors);
          const colorLabel = Number.isInteger(count) && count > 0
            ? `${count} ${count === 1 ? copy.print_color_one : copy.print_color_many}`
            : String(item.number_of_colors || '').trim();
          methods.set(JSON.stringify([item.print_group, item.number_of_colors]), colorLabel ? `${item.method} · ${colorLabel}` : item.method);
        });
        print.replaceChildren(...(product.only_print ? [] : [new Option(copy.blank, '')]));
        if (!product.only_blank) methods.forEach((label, value) => print.add(new Option(label, value)));
        updatePositions();
        updateImage();
        fields.disabled = false;
        calculate.click();
      }).catch(() => { message.textContent = copy.unavailable; });
      refreshBasket();
      window.addEventListener('storage', event => {
        if (event.key === basketKey || event.key === null) { readBasket(); refreshBasket(); }
      });
      window.addEventListener('pageshow', () => { readBasket(); refreshBasket(); });
    }
    function start() { document.querySelectorAll('[data-et-product]').forEach(initialize); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eurotex-product-catalog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(root) {
      if (root.closest('[data-et-preview-detail]') && !root.dataset.code) return;
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const $ = selector => root.querySelector(selector);
      const copy = JSON.parse($('[data-copy]').textContent);
      const fields = $('[data-fields]');
      const quantity = $('[data-quantity]'), color = $('[data-color]'), print = $('[data-print]'), position = $('[data-position]');
      const message = $('[data-message]'), summary = $('[data-summary]'), calculate = $('[data-calculate]'), checkout = $('[data-checkout]');
      const minimumWarning = $('[data-minimum-warning]');
      const stockStatus = $('[data-stock-status]');
      const basketBox = $('[data-basket]'), basketCount = $('[data-basket-count]'), basketLink = $('[data-basket-link]'), continueButton = $('[data-continue]');
      const add = $('[data-add]');
      const basketKey = 'eurotex-pilot-basket-v1';
      let product, quote = null, quotedLine = null, revision = 0, checkingOut = false, checkoutReady = false;
      let basket = [];
      let justAdded = false;
      let addResetTimer = null;
      function readBasket() {
        try {
          const saved = JSON.parse(localStorage.getItem(basketKey) || '[]');
          basket = Array.isArray(saved) ? saved.slice(0, 10).filter(item => item && item.line && item.label) : [];
        } catch (_) { basket = []; }
      }
      readBasket();
      const money = value => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(Number(value));
      function explain(reason) {
        if (reason === 'stock_requires_manual_review') return copy.stock_unknown;
        if (reason === 'printed_order_below_eurotex_minimum') return copy.minimum;
        if (reason === 'draft_orders_disabled') return copy.disabled;
        if (reason === 'request_already_processing') return copy.processing;
        if (reason === 'rate_limited') return copy.rate_limited;
        if (reason === 'price_changed' || reason === 'request_details_changed') return copy.recalculate;
        return copy.unavailable;
      }
      function invalidate() {
        revision += 1;
        quote = null;
        quotedLine = null;
        add.disabled = true;
        justAdded = false;
        basketBox.hidden = true;
        stockStatus.textContent = '';
        stockStatus.className = 'et-product__stock-status';
        summary.hidden = true;
        minimumWarning.hidden = true;
        minimumWarning.textContent = '';
        calculate.disabled = false;
        message.textContent = copy.recalculate;
      }
      function refreshBasket() {
        basketBox.hidden = basket.length === 0 || !justAdded;
        if (basket.length === 0 || !justAdded) return;
        basketCount.textContent = '✓ Toegevoegd aan je bestelling';
        basketLink.textContent = `${copy.view_cart} (${basket.length})`;
      }
      function line() {
        const result = { product_code: root.dataset.code, color_code: color.value, quantity: Number(quantity.value) };
        if (print.value) {
          const [print_group, number_of_colors] = JSON.parse(print.value);
          Object.assign(result, { print_group, number_of_colors, position: position.value });
        }
        return result;
      }
      $('[data-manual-quote]').addEventListener('click', event => {
        const request = { label: $('[data-product-title]').textContent.trim(), line: line() };
        try { sessionStorage.setItem('eurotex-manual-product-v1', JSON.stringify(request)); } catch (_) {}
        const destination = new URL(event.currentTarget.href);
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) destination.searchParams.set('preview_theme_id', preview);
        event.currentTarget.href = destination.href;
      });
      function updatePositions() {
        const [group, count] = print.value ? JSON.parse(print.value) : ['', ''];
        const options = product.print_options.filter(item => item.print_group === group && item.number_of_colors === count);
        $('[data-position-wrap]').hidden = !group;
        position.replaceChildren(...options.map(item => new Option(item.position_title || item.position, item.position)));
        if (options.some(item => item.position === 'voorzijde')) position.value = 'voorzijde';
        quantity.min = String(Math.max(product.minimum_quantity || 1, ...options.map(item => item.minimum_quantity || 1)));
        invalidate();
      }
      function updateImage() {
        const selected = product.colors.find(item => item.code === color.value);
        const image = $('[data-et-image]');
        if (image && selected && selected.image) {
          image.removeAttribute('srcset');
          image.src = selected.image;
          image.alt = `${product.title} · ${selected.title}`;
        }
        const selectedName = $('[data-selected-color]');
        if (selectedName && selected) selectedName.textContent = selected.title;
        const thumbnails = $('[data-color-thumbnails-list]');
        if (thumbnails) thumbnails.querySelectorAll('button[data-color-code]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.colorCode === color.value));
        });
      }
      function renderColorThumbnails() {
        const holder = $('[data-color-thumbnails]');
        if (!holder || !product || !Array.isArray(product.colors)) return;
        const rail = $('[data-color-thumbnails-list]');
        const fallback = $('[data-color-native]');
        if (!rail || !fallback) return;
        // Central catalog API supplies color values. Never infer colors on the client.
        // Fail closed to the existing native color selector when supplier data is incomplete.
        const hex = value => typeof value === 'string' && /^#[a-f0-9]{6}$/i.test(value);
        const options = product.colors.map(item => Object.assign({}, item, {
          swatch1: item.rgb,
          swatch2: item.rgb2
        }));
        const special = /transparant|transparent|multicolor|assorti|assorted|kleurmix|kleur mix/i;
        const valid = options.length >= 2 && options.every(item =>
          item && item.code && item.title && !special.test(item.title) &&
          /^https:\/\//i.test(item.image || '') &&
          hex(item.swatch1) && hex(item.swatch2)
        );
        if (!valid) {
          rail.replaceChildren();
          holder.hidden = true;
          fallback.hidden = false;
          root.classList.remove('et-product--color-swatches');
          return;
        }
        const buttons = options.map(item => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'et-product__thumb';
          button.dataset.colorCode = item.code;
          button.style.setProperty('--et-swatch-1', item.swatch1);
          button.style.setProperty('--et-swatch-2', item.swatch2);
          button.setAttribute('aria-label', 'Kies kleur ' + item.title);
          button.setAttribute('aria-pressed', String(color.value === item.code));
          button.title = item.title;
          button.addEventListener('click', event => {
            if (color.value === item.code) return;
            color.value = item.code;
            color.dispatchEvent(new Event('change', { bubbles: true }));
            // On mobile, reveal the newly selected product image after touch/click.
            // Do not pull keyboard focus away from the color controls.
            if (event.detail > 0 && window.matchMedia('(max-width: 749px)').matches) {
              window.requestAnimationFrame(() => {
                const image = $('[data-et-image]');
                if (!image) return;
                const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                image.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
              });
            }
          });
          return button;
        });
        rail.replaceChildren(...buttons);
        holder.hidden = false;
        fallback.hidden = true;
        root.classList.add('et-product--color-swatches');
      }
      async function api(path, payload) {
        const response = await fetch(`${root.dataset.api}${path}`, {
          method: payload ? 'POST' : 'GET', credentials: 'same-origin',
          headers: payload ? { 'Content-Type': 'application/json' } : {},
          body: payload ? JSON.stringify(payload) : undefined,
          signal: AbortSignal.timeout(60000)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(explain(data.reason));
        return data;
      }
      calculate.addEventListener('click', async () => {
        invalidate();
        if (!quantity.reportValidity() || !color.reportValidity()) return;
        const selectedLine = line();
        const current = revision;
        calculate.disabled = true;
        message.textContent = copy.calculating;
        try {
          const data = await api('/quote', { lines: [selectedLine] });
          if (current !== revision) return;
          if (data.status !== 'priced') {
            $('[data-manual-quote]').hidden = false;
            throw new Error(explain(data.reason));
          }
          $('[data-manual-quote]').hidden = true;
          quote = data;
          add.disabled = data.stock_checkout_allowed !== true;
          const stock = data.stock?.[0];
          const stockState = stock?.status === 'sufficient'
            ? 'sufficient'
            : ['insufficient', 'unavailable'].includes(stock?.status)
              ? 'insufficient'
              : 'unknown';
          stockStatus.textContent = stockState === 'sufficient'
            ? copy.stock_sufficient
            : stockState === 'insufficient'
              ? copy.stock_insufficient
              : copy.stock_unknown;
          stockStatus.className = `et-product__stock-status is-${stockState}`;
          quotedLine = selectedLine;
          $('[data-total]').textContent = money(data.total_ex_vat);
          $('[data-unit]').textContent = `${money(data.unit_price_ex_vat)} ${copy.per_piece}`;
          const belowMinimum = Boolean(selectedLine.print_group) && data.minimum_met === false;
          if (belowMinimum) {
            const shortfall = Number.isFinite(Number(data.shortfall_ex_vat)) ? Number(data.shortfall_ex_vat) : Math.max(0, 100 - Number(data.total_ex_vat));
            minimumWarning.textContent = copy.minimum_shortfall.replace('__AMOUNT__', money(shortfall));
          }
          minimumWarning.hidden = !belowMinimum;
          $('[data-selection]').textContent = `${selectedLine.quantity} ${copy.pieces} · ${color.selectedOptions[0].text} · ${print.selectedOptions[0].text}${print.value ? ` · ${position.selectedOptions[0].text}` : ''}`;
          summary.hidden = false;
          message.textContent = checkoutReady ? '' : copy.disabled;
        } catch (error) {
          if (current === revision) message.textContent = error.name === 'TimeoutError' ? copy.unavailable : error.message;
        } finally {
          if (current === revision) calculate.disabled = false;
        }
      });
      quantity.addEventListener('input', invalidate);
      color.addEventListener('change', () => { invalidate(); updateImage(); });
      print.addEventListener('change', updatePositions);
      position.addEventListener('change', invalidate);
      continueButton.addEventListener('click', () => {
        justAdded = false;
        refreshBasket();
        fields.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      add.addEventListener('click', async () => {
        if (!quote || !quotedLine) { message.textContent = copy.recalculate; return; }
        if (quote.stock_checkout_allowed !== true) {
          message.textContent = stockStatus.textContent || copy.stock_unknown;
          add.disabled = true;
          return;
        }
        readBasket();
        if (basket.length >= 10) { message.textContent = copy.max_lines; return; }
        const view = new URLSearchParams(window.location.search).get('view');
        const url = root.dataset.previewUrl || window.location.pathname + (view && /^eurotex-[a-z0-9-]+$/.test(view) ? `?view=${encodeURIComponent(view)}` : '');
        basket.push({ line: quotedLine, label: `${product.title} · ${$('[data-selection]').textContent}`, url });
        try { localStorage.setItem(basketKey, JSON.stringify(basket)); }
        catch (_) { basket.pop(); message.textContent = copy.unavailable; return; }
        window.dispatchEvent(new Event('eurotex:basket-updated'));
        message.textContent = '';
        justAdded = true;
        const originalAddLabel = add.textContent;
        add.textContent = '✓ Toegevoegd';
        add.disabled = true;
        refreshBasket();
        requestAnimationFrame(() => basketBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' }));
        if (addResetTimer) window.clearTimeout(addResetTimer);
        addResetTimer = window.setTimeout(() => {
          add.textContent = originalAddLabel;
          add.disabled = quote?.stock_checkout_allowed !== true;
        }, 1100);
      });
      if (!root.dataset.code) { message.textContent = copy.unavailable; refreshBasket(); return; }
      api(`/products/${encodeURIComponent(root.dataset.code)}`).then(data => {
        if (data.status !== 'ok') throw new Error(copy.unavailable);
        product = data.product;
        if (product.title) {
          const codeSuffix = new RegExp('\\s+' + root.dataset.code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$', 'i');
          product.title = product.title.replace(codeSuffix, '');
          $('[data-product-title]').textContent = product.title;
        }
        checkoutReady = data.checkout_enabled === true;
        // P2.8: The verified P2.8 pilot content must not be replaced by API JavaScript.
        // Other products retain the exact previous API description behavior.
        if (root.dataset.p28Static !== 'true') {
          $('[data-description]').textContent = product.description || '';
          $('[data-description-wrap]').hidden = !product.description;
        }
        color.replaceChildren(...product.colors.map(item => new Option(item.title, item.code)));
        renderColorThumbnails();
        const methods = new Map();
        product.print_options.forEach(item => {
          const count = Number(item.number_of_colors);
          const colorLabel = Number.isInteger(count) && count > 0
            ? `${count} ${count === 1 ? copy.print_color_one : copy.print_color_many}`
            : String(item.number_of_colors || '').trim();
          methods.set(JSON.stringify([item.print_group, item.number_of_colors]), colorLabel ? `${item.method} · ${colorLabel}` : item.method);
        });
        print.replaceChildren(...(product.only_print ? [] : [new Option(copy.blank, '')]));
        if (!product.only_blank) methods.forEach((label, value) => print.add(new Option(label, value)));
        updatePositions();
        quantity.value = String(Math.max(Number(quantity.value) || 75, Number(quantity.min) || 1));
        updateImage();
        fields.disabled = false;
        calculate.click();
      }).catch(() => { message.textContent = copy.unavailable; $('[data-manual-quote]').hidden = false; });
      refreshBasket();
      window.addEventListener('storage', event => {
        if (event.key === basketKey || event.key === null) { readBasket(); refreshBasket(); }
      });
      window.addEventListener('pageshow', () => { readBasket(); refreshBasket(); });
    }
    function start() { document.querySelectorAll('[data-et-product]').forEach(initialize); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
    document.addEventListener('eurotex:preview-ready', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const key = 'eurotex-pilot-basket-v1';
    function updateCartCount() {
      const link = document.querySelector('[data-eurotex-cart-link]');
      if (!link) return;
      let count = 0;
      try {
        const saved = JSON.parse(localStorage.getItem(key) || '[]');
        if (Array.isArray(saved)) count = saved.slice(0, 10).filter(item => item && item.line && item.label).length;
      } catch (_) { count = 0; }
      const bubble = link.querySelector('[data-eurotex-cart-count]');
      bubble.hidden = count === 0;
      link.querySelector('[data-eurotex-count]').textContent = String(count);
      link.querySelector('[data-eurotex-cart-description]').textContent = count
        ? `${count} ${count === 1 ? link.dataset.countOne : link.dataset.countMany}`
        : '';
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateCartCount);
    else updateCartCount();
    window.addEventListener('eurotex:basket-updated', updateCartCount);
    window.addEventListener('pageshow', updateCartCount);
    window.addEventListener('storage', event => {
      if (event.key === key || event.key === null) updateCartCount();
    });
    document.addEventListener('shopify:section:load', updateCartCount);
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
